import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/move';

/** 状況 `move_material`（組み立ては `../fx/move.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'move_material', role: 'effect', ...spec }, 'move_material_effect.js');
